import { ProfileColor } from "../../../dispatch/src/ProfileColor";
import { Checkbox, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutInvoiceProcessingProfile extends Layout {
    checkboxAgentExclude: Checkbox;
    checkboxBillingUserIdExclude: Checkbox;
    checkboxControllingPartyExclude: Checkbox;
    checkboxCustomerCategoryExclude: Checkbox;
    checkboxCustomerIdExclude: Checkbox;
    checkboxInvoiceProcessorExclude: Checkbox;
    checkboxMovementTypeExclude: Checkbox;
    checkboxOrderAllocationExclude: Checkbox;
    checkboxOrderTypeExclude: Checkbox;
    checkboxRevenueCodeExclude: Checkbox;
    horizontalspacerBilling: HorizontalSpacer;
    horizontalspacerOrder: HorizontalSpacer;
    horizontalspacerProfile: HorizontalSpacer;
    labelBillingDetails: Label;
    labelOrderDetails: Label;
    labelProfileDetails: Label;
    layoutProfileColor: ProfileColor;
    panelBillingDetails: Panel;
    panelHierarchyLevel: Panel;
    panelLeft: Panel;
    panelProfileDetails: Panel;
    panelRight: Panel;
    sourceInvoiceProcessingProfile: DataSource;
    switchEnableTransfer: Switch;
    textboxAgents: Textbox;
    textboxBillStatus: Textbox;
    textboxBillType: Textbox;
    textboxBillingUserIds: Textbox;
    textboxControllingParty: Textbox;
    textboxCustomerCategories: Textbox;
    textboxCustomerIds: Textbox;
    textboxId: Textbox;
    textboxIntercompany: Textbox;
    textboxInvoiceProcessorIds: Textbox;
    textboxMovementType: Textbox;
    textboxOrderAllocations: Textbox;
    textboxOrderResponsibilityLevel: Textbox;
    textboxOrderTypes: Textbox;
    textboxRateOrigin: Textbox;
    textboxResponsibilityCodes: Textbox;
    textboxRevenueCodes: Textbox;
    textboxTitle: Textbox;
}
